const state = {
    location: undefined,
}

const getters = {}

const mutations = {
    setCurrentLocation(state, location) {
        state.location = location
    },
}

const actions = {
    async fetch({ commit }, getLocation) {
        let coordinates

        try {
            coordinates = await getLocation()
        } catch (error) {
            return Promise.reject(error)
        }

        if (coordinates.lat !== undefined && coordinates.lng !== undefined) {
            commit('setCurrentLocation', coordinates)
        } else {
            return Promise.reject(new Error('Координаты не получены'))
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
